module.exports = __webpack_public_path__ + "static/Materiales respirables-9242e540f00a56302d6692ba9f55cf46.png";